module.exports = __webpack_public_path__ + "static/54-c1a71a345733253cd5a934568973bed5.png";